import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid2';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tour-content.reducer';

const FieldLabel = ({ children }: { children: React.ReactNode }) => (
  <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
    {children}
  </Typography>
);

const FieldValue = ({ children, sx }: { children: React.ReactNode; sx?: object }) => (
  <Typography variant="body1" sx={{ mb: 2, ...sx }}>
    {children || '-'}
  </Typography>
);

export const TourContentDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const tourContentEntity = useAppSelector(state => state.tourContent.entity);
  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', mt: 4, p: 2 }}>
      <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', gap: 2 }}>
        <h2 data-cy="tourContentDetailsHeading">
          <Translate contentKey="jhipsterSampleApplicationApp.tourContent.detail.title">TourContent</Translate>
        </h2>
        {tourContentEntity.id && (
          <Box sx={{ bgcolor: 'primary.light', color: 'primary.contrastText', px: 2, py: 0.5, borderRadius: 1, fontWeight: 'bold' }}>
            ID: {tourContentEntity.id}
          </Box>
        )}
      </Box>

      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 6 }}>
          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourContent.code" />
          </FieldLabel>
          <FieldValue>{tourContentEntity.code}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourContent.tour" />
          </FieldLabel>
          <FieldValue>{tourContentEntity.tour ? tourContentEntity.tour.code : ''}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourContent.title" />
          </FieldLabel>
          <FieldValue>{tourContentEntity.title}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourContent.shortDescription" />
          </FieldLabel>
          <FieldValue>{tourContentEntity.shortDescription}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourContent.data" />
          </FieldLabel>
          <FieldValue sx={{ whiteSpace: 'pre-wrap' }}>{tourContentEntity.data}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourContent.meta" />
          </FieldLabel>
          <FieldValue sx={{ whiteSpace: 'pre-wrap' }}>{tourContentEntity.meta}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourContent.cancellation" />
          </FieldLabel>
          <FieldValue sx={{ whiteSpace: 'pre-wrap' }}>{tourContentEntity.cancellation}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourContent.activityPath" />
          </FieldLabel>
          <FieldValue>{tourContentEntity.activityPath}</FieldValue>
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourContent.atAGlance" />
          </FieldLabel>
          <FieldValue sx={{ whiteSpace: 'pre-wrap' }}>{tourContentEntity.atAGlance}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourContent.inDetail" />
          </FieldLabel>
          <FieldValue sx={{ whiteSpace: 'pre-wrap' }}>{tourContentEntity.inDetail}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourContent.whatIsIncluded" />
          </FieldLabel>
          <FieldValue sx={{ whiteSpace: 'pre-wrap' }}>{tourContentEntity.whatIsIncluded}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourContent.youCanAdd" />
          </FieldLabel>
          <FieldValue sx={{ whiteSpace: 'pre-wrap' }}>{tourContentEntity.youCanAdd}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourContent.importantInformation" />
          </FieldLabel>
          <FieldValue sx={{ whiteSpace: 'pre-wrap' }}>{tourContentEntity.importantInformation}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourContent.extraInfo" />
          </FieldLabel>
          <FieldValue sx={{ whiteSpace: 'pre-wrap' }}>{tourContentEntity.extraInfo}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourContent.createdDate" />
          </FieldLabel>
          <FieldValue>
            {tourContentEntity.createdDate ? (
              <TextFormat value={tourContentEntity.createdDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourContent.language" />
          </FieldLabel>
          <FieldValue>{tourContentEntity.language ? tourContentEntity.language.code : ''}</FieldValue>
        </Grid>

        <Grid size={12}>
          <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
            <Button
              component={Link}
              to="/tour-content"
              replace
              color="info"
              variant="outlined"
              startIcon={<FontAwesomeIcon icon="arrow-left" />}
            >
              <Translate contentKey="entity.action.back">Back</Translate>
            </Button>
            <Button
              component={Link}
              to={`/tour-content/${tourContentEntity.id}/edit`}
              replace
              color="primary"
              variant="contained"
              startIcon={<FontAwesomeIcon icon="pencil-alt" />}
            >
              <Translate contentKey="entity.action.edit">Edit</Translate>
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TourContentDetail;
